import moment from 'moment';

const AppFooter = () => {
    return (
        <div className="layout-footer diligentec-text-blue" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem 1rem' }}>
            <div className="left-section" style={{ display: 'flex', alignItems: 'center' }}>
            </div>
            <div className="right-section">
                <span>Copyright © {moment().format('YYYY')} </span>
                <span className="font-medium">Diligent ERP. </span>
                <span>Todos los derechos reservados.</span>
            </div>
        </div>
    );
};

export default AppFooter;